// extracted by mini-css-extract-plugin
export var section = "experience-module--section--1mWDz";
export var head = "experience-module--head--2znhp";
export var head_left = "experience-module--head_left--k0Mkh";
export var animate = "experience-module--animate--3RGl4";
export var head_right = "experience-module--head_right--2ULYa";
export var list = "experience-module--list--LnSgm";
export var list_icon = "experience-module--list_icon--2GSmf";